export enum SheetView {
  LIST = 'LIST',
  GRID = 'GRID'
}
